import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const StarShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410.4 390.7",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M288.3 238.1l122.2-88.8h-151c-3.5-.1-6.6-2.4-7.6-5.7L205.2 0l-46.6 143.7c-1.1 3.3-4.1 5.6-7.6 5.7H0l122.2 88.8c2.8 2 4 5.6 2.9 8.8L78.4 390.7 200.5 302c2.8-2 6.6-2 9.4 0L332 390.6l-46.6-143.7c-1.1-3.2.1-6.8 2.9-8.8z"
    })
  });
};

export { StarShape };
//# sourceMappingURL=StarShape.js.map
